import apiClient from "../axios.config";

const ownerAgrementServices = {
  postAgreementInfo(payload) {
    return apiClient.post("owner/agreement/agreement-preview", payload);
  },
  getAgreementInfo(propertyGuid) {
    return apiClient.get(`/owner/agreement/property/${propertyGuid}`);
  },
  updateProfileInfo(payload) {
    return apiClient.put("/owner/profile/basic", payload);
  },
};

export default ownerAgrementServices;
